import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate, NavLink } from 'react-router-dom';
import { put } from '../../utils/api';
import CategoryForm from './CategoryForm';
import CategoryDelete from './CategoryDelete';


const CategoryEdit = () => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
	const navigate = useNavigate();
    const event = useSelector(state => state.event);
    const category = useSelector(state => state.category);
	const [ name_ru, setNameRu ] = useState(category.name.ru);
	const [ name_en, setNameEn ] = useState(category.name.en);
    const [ priority, setPriority ] = useState(category.priority + '');
    const [ folder, setFolder ] = useState(category.folder);
	const [ isLoading, setIsLoading ] = useState(false);
	const [ error, setError ] = useState('');
    const [ success, setSuccess ] = useState('');

    // Отправка
	const onSubmit = async () => {
        setIsLoading(true);
        setError('');
        setSuccess('');
        const result = await put('/categories/' + category._id, { name_ru, name_en, folder, priority });
        if(result.error) {
            setError(result.error);
        } else {
            setSuccess('category.editsuccess');
			navigate('/cabinet/eventview/' + event._id + '/action/updated');
        }
        setIsLoading(false);
	};

    return (
		<div>
	    	<h1>{t('category.edittitle')}</h1>
			{isLoading ? <span>{t('common.loading')}</span> :
            <React.Fragment>
                <CategoryForm
                    success={success}
                    error={error}
                    info={t('category.editsubtitle') + event.name[lang]}
                    submit='category.editsubmit'
                    type={category.type}
                    folder={folder}
                    isFolder={category.is_folder}
                    nameRu={name_ru}
                    nameEn={name_en}
                    priority={priority}
                    setNameRu={setNameRu}
                    setNameEn={setNameEn}
                    setFolder={setFolder}
                    setPriority={setPriority}
                    onSubmit={onSubmit}
                />
                <CategoryDelete
                    event_id={event._id}
                    category_id={category._id}
                />
                <p>
                    <NavLink to={'/cabinet/eventview/' + event._id}>{t('category.back')}</NavLink>
                </p>
            </React.Fragment>
            }
		</div>
	);
};

export default CategoryEdit;
